import React from 'react'
import { LayoutGrid, Network, Zap, Boxes } from 'lucide-react'

export type TopologyMode = 'summary' | 'subnet' | 'attack' | 'all'

interface TopologyToolbarProps {
  mode:     TopologyMode
  onChange: (next: TopologyMode) => void
}

const MODES: { key: TopologyMode; label: string; icon: React.ReactNode; description: string }[] = [
  { key: 'summary', label: 'Summary',    icon: <LayoutGrid className="h-3.5 w-3.5" />, description: 'Engagement → subnets → high-risk hosts' },
  { key: 'subnet',  label: 'Subnet view', icon: <Boxes className="h-3.5 w-3.5" />,      description: 'Hosts grouped inside subnet containers' },
  { key: 'attack',  label: 'Attack path', icon: <Zap className="h-3.5 w-3.5" />,        description: 'Filter to nodes/edges with attack data' },
  { key: 'all',     label: 'All hosts',   icon: <Network className="h-3.5 w-3.5" />,    description: 'Every host on the canvas (current view)' },
]

export const TopologyToolbar: React.FC<TopologyToolbarProps> = ({ mode, onChange }) => (
  <div className="inline-flex rounded-md border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 p-0.5">
    {MODES.map(m => {
      const active = mode === m.key
      return (
        <button
          key={m.key}
          type="button"
          onClick={() => onChange(m.key)}
          title={m.description}
          aria-pressed={active}
          className={`inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded transition-colors ${
            active
              ? 'bg-blue-500 text-white shadow-sm'
              : 'text-slate-600 hover:bg-slate-50 dark:text-slate-300 dark:hover:bg-slate-700'
          }`}
        >
          {m.icon}
          {m.label}
        </button>
      )
    })}
  </div>
)
